// Components==============
// =========================

export const useSparkGroups = (
  sparks: (SparkEntity | undefined)[] | undefined
) => {
  let sparkGroups: SparkEntity[][] = [];

  sparks?.forEach((spark) => {
    if (!spark) return;
    if (
      sparkGroups.find(
        (group) =>
          group[0].heading.toLowerCase() === spark?.heading.toLowerCase()
      )
    ) {
      const index = sparkGroups
        .map((group, i) =>
          group[0].heading.toLowerCase() === spark.heading.toLowerCase()
            ? i
            : undefined
        )
        .filter((group) => group === 0 || !!group)[0];

      if (index || index === 0) return sparkGroups[index].push(spark);
      return;
    }

    sparkGroups.push([spark]);
  });
  sparkGroups = sparkGroups.sort((a, b) => {
    const heading1 = a[0].heading;
    const heading2 = b[0].heading;
    if (heading1 < heading2) {
      return -1;
    }
    if (heading1 > heading2) {
      return 1;
    }
    return 0;
  });

  return sparkGroups;
};
